export function fromPspdfkitType(type: string) {
  return type.replace(/-/g, '_').toUpperCase();
}
